module.exports = __webpack_public_path__ + "img/cultureOpen2.dcf5ab42.png";